




































































































































import {cloneDeep} from 'lodash';
import {Component, Vue} from 'vue-property-decorator';
import TableCheckBox from '@c/tables/TableCheckBox.vue';
import IconButton from '@c/controls/IconButton.vue';
import Loading from '@c/controls/Loading.vue';
import CancelChangesDialog from '@c/CancelChangesDialog.vue';
import EditDialog from '@c/EditDialog.vue';
import router from '@/router';
import oilModule from '@/store/modules/entities/oilModule';
import {OilNodeData, OilNodeMeasurement, OilNodeTableHeader, NodeFlatList} from './interfaces';
import measurementsStoreModule from '@/store/modules/entities/measurementsModule';
import nodeModule from '@/store/modules/entities/nodeModule';
import {NodeData} from '@/system/nodes/interfaces';

@Component({
  components: {
    TableCheckBox,
    IconButton,
    EditDialog,
    CancelChangesDialog,
    Loading,
  },
})
export default class OilView extends Vue {
  loading = true;
  error = false;
  saving = false;
  valid = true;
  editDialog = false;

  oilNode: OilNodeData = {nodeId: 0, measurements: []};
  nodes: NodeFlatList[] = [];
  mdata: OilNodeMeasurement = {};

  nonEmptyTextRule = (v: any) => !!v || (v && v.length === 0) || 'Поле обязательно для заполнения';
  RegExPattern = /^([0-9A-Fa-f]{12})$/;
  nonEmptyNumberRule = (v: any) => v != null || 'Поле обязательно для заполнения';
  nonNegativeNumberRule = (v: any) => v >= 0 || 'Поле должно быть неотрицательным числом';
  integerNumberRule = (v: any) => Number.isInteger(Number(v)) || 'Поле должно быть целым числом';

  measurements_list: OilNodeMeasurement[] = [];

  measurementsHeaders: OilNodeTableHeader[] = [
    {
      text: 'Наименование',
      value: 'name',
      sortable: true,
    },
    {
      text: 'Верхняя граница предупреждения',
      value: 'topWarningBoundary',
      sortable: false,
    },
    {
      text: 'Верхняя граница опасного значения',
      value: 'topDangerBoundary',
      sortable: false,
    },
    {
      text: 'Верхняя граница ошибки',
      value: 'topErrorBoundary',
      sortable: false,
    },
    {
      text: 'Нижняя граница предупреждения',
      value: 'bottomWarningBoundary',
      sortable: false,
    },
    {
      text: 'Нижняя граница опасного значения',
      value: 'bottomDangerBoundary',
      sortable: false,
    },
    {
      text: 'Нижняя граница ошибки',
      value: 'bottomErrorBoundary',
      sortable: false,
    },
    {
      text: '',
      value: 'actions',
      sortable: false,
    },
  ];

  checkCorrectLevelNode = (parentType: number, node: NodeData) => node.type < parentType;

  checkChildren(item: NodeData) {
    if (item.children && item.children.length) {
      item.children.forEach(node => {
        if (item.children && item.children.length) {
          if (this.checkCorrectLevelNode(item.type, node)) {
            node.leveTypeError = true;
          }
          node.parent = {name: item.name, type: item.type};
          this.checkChildren(node);
        }
        return;
      });
    }
  }

  flattenTreeWithPath(nodes: NodeData[], parentPath: string[] = [], result: NodeFlatList[] = []) {
    nodes.forEach((node: NodeData) => {
      const currentPath = [...parentPath, node.name];
      result.push({
        id: node.id,
        name: node.name,
        path: currentPath.join(' > '),
        level: parentPath.length,
      });
      if (node.children && node.children.length) {
        this.flattenTreeWithPath(node.children, currentPath, result);
      }
    });
    return result;
  }

  async onSave() {
    const err_container = this.$refs.err_text as any;
    this.valid = await (this.$refs.form as any).validate();
    if (!this.valid) {
      const error = document.querySelector('div.error--text');
      error && this.$vuetify.goTo(error as HTMLElement);
      return;
    }
    if (err_container) err_container.innerText = 'Обрабатываю...';
    try {
      await oilModule.save(this.oilNode);
    } catch (err) {
      console.log(err);
      if (err_container) err_container.innerText = 'Ошибка обновления: ' + err;
      return;
    }
    if (err_container) err_container.innerText = '';
    router.push('/oil');
  }

  editMeasurement(item: any) {
    this.mdata = {...item};
    this.editDialog = true;
  }

  saveMeasurement() {
    const index = this.measurements_list.findIndex((i: any) => i.id === this.mdata.id);
    if (index !== -1) {
      this.$set(this.measurements_list, index, {...this.mdata});
    }
    const ind = this.oilNode.measurements.findIndex((i: any) => i.id === this.mdata.id);
    if (ind !== -1) {
      this.oilNode.measurements[ind] = {...this.mdata};
    }
    this.editDialog = false;
    this.mdata = {};
  }

  closeMeasurement() {
    this.editDialog = false;
  }

  //переменная, сигнализирующая о внесенных и несохраненных изменениях на форме
  changed = false;

  // Действия при изменении поля
  async onChange() {
    this.changed = true;
  }

  async created() {
    await oilModule.fetchAll();
    await nodeModule.fetchAll();
    try {
      const temp = cloneDeep(nodeModule.all);
      temp.forEach(item => {
        this.checkChildren(item);
      });
      this.nodes = this.flattenTreeWithPath(temp);
    } catch {
      this.error = true;
    }
    const oId = this.$router.currentRoute.params.id;
    if (oId) {
      const {data} = await oilModule.edit(oId);
      this.oilNode = data;
    } else {
      const {data} = await oilModule.create();
      this.oilNode = data;
    }
    await measurementsStoreModule.fetchAll();
    this.measurements_list = measurementsStoreModule.entities
      .filter((ms: any) => ms.moduleType == 'OilNodes')
      .map((m: any) => {
        const elem: OilNodeMeasurement | undefined = this.oilNode.measurements.find(
          elem => elem.id == m.id,
        );
        if (elem) m = elem;
        return {
          id: m.id,
          name: m.name,
          topWarningBoundary: m.topWarningBoundary,
          topDangerBoundary: m.topDangerBoundary,
          topErrorBoundary: m.topErrorBoundary,
          bottomWarningBoundary: m.bottomWarningBoundary,
          bottomDangerBoundary: m.bottomDangerBoundary,
          bottomErrorBoundary: m.bottomErrorBoundary,
        };
      });
    this.loading = false;
  }

  back() {
    const cancelChangesDialog = this.$refs.cancelChangesDialog as any;
    // если были внесены изменения на форме
    if (this.changed) {
      cancelChangesDialog.open('/oil');
    } else router.push('/oil');
  }
}
